export const setEmailTemplateInfo=(data)=>{
    return {
        type: "SET_EMAIL_TEMPLATE_INFO",
        info: data,
    }
}
export const nullEmailTemplateInfo=()=>{
    return{
        type:"NULL_EMAIL_TEMPLATE_INFO",
        info: null
    }
}
export const getEmailTemplateInfo=()=>{
    return {
        type: "GET_EMAIL_TEMPLATE_INFO",
        
    }
}
